import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const toToolkitApplicationState = (state: ApplicationState) => state as Toolkit.Store.ApplicationState;
